import React, { useContext, useState } from 'react'
import {
    Box,
    Stack,
    TextField,
    Typography,
} from '@mui/material'
import emailjs from '@emailjs/browser'

import Header from '../../utils/header.js'
import { AppContext } from '../../context/context/context.js'
import { ColorButton } from '../../utils/button.js'

import data from '../../data/reservation.json'

const Reservation = () => {
    const { state } = useContext(AppContext)
    const [name, setName] = useState('')
    const [number, setNumber] = useState('')
    const [date, setDate] = useState('')

    const contactImg = 'https://firebasestorage.googleapis.com/v0/b/elaraby-photographer.appspot.com/o/contact.webp?alt=media&token=10c313cf-25cf-4945-a9b7-d0d0c813526d'

    const handleSubmit = (e) => {
        e.preventDefault()

        emailjs.send(data.serviceID, data.templateID, {
            name: name,
            phone_number: number,
            date: date,
        }, data.publicKey)
            .then(alert("Email was sent successfully"))
            .catch(err => alert(err.message))
    }

    return (
        <Box
            data-aos="fade-up"
            textAlign={"center"}
            padding={{ xs: "8% 8% 0%", md: "3% 5% 0%" }}
        >
            <Header color={state.color.dark} title="BOOK YOUR NEXT PHOTOSHOOT" />
            <Stack
                direction={{ xs: "column-reverse", md: "row" }}
                justifyContent="center"
                alignItems={"center"}
                py={5}
                spacing={{ xs: 6, sm: 8, md: 10 }}
            >
                <Box
                    sx={{ width: { xs: "90%", md: "50%", xl: "30%" }, }}>
                    <form onSubmit={handleSubmit}>
                        <Stack
                            sx={{ justifyContent: { xs: 'center', md: "flex-start" }, }}>
                            <TextField
                                type="text"
                                variant='outlined'
                                label="Name"
                                onChange={e => setName(e.target.value)}
                                value={name}
                                fullWidth
                                required
                                sx={{ mb: 4 }}
                            />
                            <TextField
                                type="text"
                                variant='outlined'
                                label="Phone Number"
                                onChange={e => setNumber(e.target.value)}
                                value={number}
                                fullWidth
                                required
                                sx={{ mb: 4 }}
                            />
                            <TextField
                                type="date"
                                variant='outlined'
                                label="Date of reservation"
                                onChange={e => setDate(e.target.value)}
                                onSelect={e => setDate(e.target.value)}
                                value={date}
                                InputLabelProps={{ shrink: true }}
                                fullWidth
                                required
                                sx={{ mb: 4 }}
                            />
                            <ColorButton
                                variant="contained"
                                type="submit"
                                size='large'
                                sx={{ width: { xs: 1, md: 1 / 2 }, mt: 5 }}
                            >Send</ColorButton>
                        </Stack>
                    </form>
                    <Stack
                        direction={{ xs: "column" }}
                        justifyContent="center"
                        alignItems={"center"}
                        spacing={{ xs: 2 }}
                        mt={10}>
                        <Typography
                            variant='p'
                            sx={{ textAlign: "center", mt: 5 }}>
                            ــــــــ Or Call Me ــــــــ
                        </Typography>
                        <Stack
                            direction={{ xs: "row" }}
                            justifyContent="space-between"
                            alignItems={"center"}
                            spacing={{ xs: 2 }}>
                            <Typography
                                component={"a"}
                                href="tel:01000829490"
                                sx={{
                                    textDecoration: "none",
                                    color: "#123456"
                                }}>
                                +20 100 082 9490
                            </Typography>
                            <Typography
                                component={"a"}
                                href="https://wa.me/+201114911647"
                                sx={{
                                    textDecoration: "none",
                                    color: "#123456"
                                }}>
                                +20 111 491 1647
                            </Typography>
                        </Stack>
                    </Stack>
                </Box>
                <Box
                    component={"img"}
                    src={contactImg}
                    alt={"El Araby Photographer"}
                    sx={{ width: { xs: "90%", md: "50%", xl: "30%" }, }}>
                </Box>
            </Stack>
        </Box>
    )
}

export default Reservation